import { EnfantsOrdonnes } from '@pcscol/odf-api-v1-angular';
import { OperationOrdonnancementEnfant, OrdonnerEnfantRequest } from '../ordonner-enfant-request.model';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { UndoCommand } from './command';
import { CommandEvents } from './command-events';

export class OrdonnerEnfantCommand implements UndoCommand<EnfantsOrdonnes> {
    constructor(
        private idParent: string,
        private idEnfant: string,
        private events: CommandEvents,
        private objetMaquetteService: ObjetMaquetteService,
        private idsEnfantsAvant: string[],
        private idsEnfantsApres: string[]
    ) {}

    do(): Observable<EnfantsOrdonnes> {
        return this.executerOrdonnancement(this.idsEnfantsAvant, this.idsEnfantsApres);
    }

    undo(): Observable<EnfantsOrdonnes> {
        return this.executerOrdonnancement(this.idsEnfantsApres, this.idsEnfantsAvant);
    }

    destroy(): void {}

    private executerOrdonnancement(idsEnfantsCourants: string[], idsEnfantsCibles: string[]): Observable<EnfantsOrdonnes> {
        const requete = this.construireRequeteOrdonnancement(idsEnfantsCourants, idsEnfantsCibles);
        if (!requete) {
            return of({ items: [] });
        }

        return this.objetMaquetteService.ordonnerEnfant(this.idParent, this.idEnfant, requete).pipe(
            tap(() => {
                this.events.structureModifiee$.next(this.idParent);
            })
        );
    }

    private construireRequeteOrdonnancement(idsEnfantsCourants: string[], idsEnfantsCibles: string[]): OrdonnerEnfantRequest | null {
        const indexCourant = idsEnfantsCourants.indexOf(this.idEnfant);
        const indexCible = idsEnfantsCibles.indexOf(this.idEnfant);

        if (indexCourant < 0 || indexCible < 0 || indexCourant === indexCible) {
            return null;
        }

        if (indexCible === 0) {
            return { operation: OperationOrdonnancementEnfant.Debut };
        }

        if (indexCible === idsEnfantsCibles.length - 1) {
            return { operation: OperationOrdonnancementEnfant.Fin };
        }

        return {
            operation: OperationOrdonnancementEnfant.Entre,
            intervalle: {
                debut: idsEnfantsCibles[indexCible - 1],
                fin: idsEnfantsCibles[indexCible + 1]
            }
        };
    }
}
